import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { reserveButton, mobileOrderPickupButton } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a
              href="https://resy.com/cities/victoria-bc-canada-bc/venues/ox-korean-bbq"
              target="_blank"
            >
              <CFView hover>
                <CFImage
                  src={reserveButton}
                  w="100%"
                  maxWidth="230px"
                  alt="mobile Reserve button"
                />
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a
              href="https://resy.com/cities/victoria-bc-canada-bc/venues/ox-korean-bbq"
              target="_blank"
            >
              <CFView hover>
                <CFImage
                  src={reserveButton}
                  w="100%"
                  maxWidth="220px"
                  alt="ReserveButton"
                />
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
